import CraftEdit from 'src/components/CraftEdit';
import PassportForm from './PassportForm';

const PassportEdit = () => (
  <CraftEdit resource="passport" header="Edit Passport" redirect={false} mutationMode="pessimistic">
    <PassportForm formType="edit" />
  </CraftEdit>
);

export default PassportEdit;
